export const isAdmin = user => {
    if (!user) return false;

    return ['root', 'bac-user', 'bac-admin'].includes(user.role)
};
